import {
  CHECK_CLASSROOM_TRAINING_REQUIRED_SUCCESS,
  CLEAR_CERTIFICATION_DATA,
  REQUIREMENT_PREREQUISITE_STATUS_SUCCESS,
  SET_OPEN_ERRORS_TAB_CERTIFICATION,
} from '../actions/CertificationActions';
import { SET_SUBMIT_INITIATED } from '../containers/CertificationPage/constants';

const initialState = {
  classRoomTrainingIsRequired: null,
  preRequisiteIsRequired: null,
  message: null,
  openErrorsTab: false,
  submitInitiated: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_CLASSROOM_TRAINING_REQUIRED_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        classRoomTrainingIsRequired: action.payload.classRoomTrainingIsRequired,
      };

    case REQUIREMENT_PREREQUISITE_STATUS_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        preRequisiteIsRequired: action.payload.preRequisiteIsRequired,
        preRequisiteStatus: action.payload.preRequisiteStatus,
        preRequisites: action.payload.preRequisites,
      };

    case SET_OPEN_ERRORS_TAB_CERTIFICATION:
      return {
        ...state,
        openErrorsTab: action.payload.openErrorsTab,
      };

    case SET_SUBMIT_INITIATED:
      return {
        ...state,
        submitInitiated: action.payload.isSubmitInitiated,
      };

    case CLEAR_CERTIFICATION_DATA:
      return initialState;

    default:
      return state;
  }
};
